var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12.796 4.05c0-.344.28-.624.626-.624h3.726v3.727a.625.625 0 11-1.25 0V5.618l-5.018 5.288a.625.625 0 01-.906-.86l5.095-5.37H13.42a.625.625 0 01-.624-.625zm-8.004.742H9.97a.625.625 0 000-1.25H4.583c-.575 0-1.041.466-1.041 1.041V16.25c0 .575.466 1.041 1.041 1.041H16.25c.575 0 1.042-.466 1.042-1.041v-5.387a.625.625 0 00-1.25 0v5.178H4.792V4.791z"
  })));
}
export default SvgExternalLinkIcon;